import {
    observable,
    action,
    computed,
    toJS,
    runInAction
  } from 'mobx';
  import {ViewBase} from 'mutants-appfx';


  class SiderLeft extends ViewBase {
    get type(){
      return 'SiderLeft';
    }

    @observable siderLeftVM;

    constructor(store,name,SiderLeftVM){
      super(store,name)
      runInAction(()=>{
        this.siderLeftVM=SiderLeftVM;
      })
    }

    static fromJS(store,{SiderLeft:SiderLeftVM}) {
      return new SiderLeft(store, 'SiderLeft',SiderLeftVM)
    }

  }
  export default SiderLeft;
